import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { SETTING_OFFICES_SEARCH_COLUMNS } from "./consts";
import { OfficesSearchResultsProps } from "./types";

const OfficesSearchResults: React.FC<OfficesSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onEventClick,
    onPaginationChange,
    onSelectedChange,
  } = props;

  return (
    <>
      <TableSearch
        columns={SETTING_OFFICES_SEARCH_COLUMNS}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
        onEventClick={onEventClick}
      />
    </>
  );
};
export default memo(OfficesSearchResults);
